// Experience.jsx
import React from "react";
import "./Experience.css";

const Experience = () => {
  const experience = [
    {
      id: 1,
      role: "Associate Professor",
      company: "Pimpri Chinchwad University, Pune",
      period: "Aug 2023 – Present",
      category: "Academia",
    },
    {
      id: 2,
      role: "Director - Business Development",
      company: "MK Process Technologies Pvt Ltd, New Delhi",
      period: "Oct 2019 – Aug 2023",
      category: "Corporate",
    },
    {
      id: 3,
      role: "Director - Business Development",
      company: "Crossways Vertical Solutions Pvt Ltd, New Delhi",
      period: "Dec 2016 – Oct 2019",
      category: "Corporate",
    },
    {
      id: 4,
      role: "Coordinator & Assistant Professor",
      company: "I.T.S Engineering College, Greater Noida",
      period: "Jul 2010 – Nov 2016",
      category: "Academia",
    },
    {
      id: 5,
      role: "Assistant Professor",
      company: "Greater Noida Institute of Technology",
      period: "Sep 2008 – Jul 2010",
      category: "Academia",
    },
    {
      id: 6,
      role: "Lecturer",
      company: "Apeejay Institute of Technology, Greater Noida",
      period: "Dec 2007 – Sep 2008",
      category: "Academia",
    },
    {
      id: 7,
      role: "Lecturer",
      company: "RKGIT, Ghaziabad",
      period: "Sep 2004 – Nov 2007",
      category: "Academia",
    },
    {
      id: 8,
      role: "Audit Manager",
      company: "SNRS, New Delhi",
      period: "Aug 2000 – Aug 2004",
      category: "Corporate",
    },
    {
      id: 9,
      role: "Article Trainee",
      company: "P.R. Mehra & Co, New Delhi",
      period: "Aug 1997 – Jul 2000",
      category: "Training",
    },
  ];

  return (
    <section className="experience-section" id="experience">
      <div className="container">

        <div className="exp-header">
          <h2>Professional Experience</h2>
          <p>
            A detailed overview of academic, corporate, and training experience
            spanning over two decades.
          </p>
        </div>

        <div className="experience-grid">
          {experience.map((exp, idx) => (
            <div
              key={exp.id}
              className="experience-card"
              data-aos="fade-up"
              data-aos-delay={idx * 60}
            >
              <span className="exp-category">{exp.category}</span>

              <h3 className="exp-role">{exp.role}</h3>

              <p className="exp-company">{exp.company}</p>

              <span className="exp-period">{exp.period}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Experience;
